<template>
  
</template>
<script>
  export default {
      name: 'web',
      data() {
        return {
          device:'',
          url:''
        };
      },
      props: {
      },
      mounted() {
        this.device = this.getClientInfo();
        var url = '';
        if(window.location.origin == 'https://intecls.zens10.com' || window.location.origin == 'http://localhost:8080'){
          url = 'https://lite.zens10.com/'
        } else {
          url = 'https://app.zens10.com/'
        };
        this.url = url;
      },
      methods: {
        getClientInfo() {
          var userAgentInfo = navigator.userAgent;
          var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
          var agentinfo = null;
          for (var i = 0; i < Agents.length; i++) {
              if (userAgentInfo.indexOf(Agents[i]) > 0) { agentinfo = userAgentInfo; break; }
          }
          if (agentinfo) {
              return "mobile";
          } else {
              return "PC";
          }
        },

        font_resize(){
          var size=document.documentElement.clientWidth / 750 * 100;
          document.querySelector('html').style.fontSize=size + 'px';
        },

        numberToChinese(num) {
          const chineseNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
          const chineseUnits = ['', '十', '百', '千', '万', '亿', '兆'];
        
          if (num === 0) {
            return chineseNums[0];
          }
        
          const digits = Math.floor(num).toString().split('');
          const len = digits.length;
          
          let result = '';
          
          for (let i = 0; i < len; i++) {
            const digit = parseInt(digits[i]);
            const unit = chineseUnits[len - 1 - i];
            
            if (digit !== 0) {
              result += chineseNums[digit] + unit;
            } else {
              if (result[result.length - 1] !== chineseNums[0]) {
                result += chineseNums[digit]
              }
            }
          }
          
          return result;
        }
      }
  }
</script>
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/comment/web.vue